import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function BusinessDashboardPage() {
  const [data, setData] = useState({
    user: { name: 'Doanh nghiệp', company: '...' },
    stats: { activeJobs: 0, newCandidates: 0, completedTests: 0 },
    jobs: [],
    tests: [],
    activities: []
  });
  const [loading, setLoading] = useState(true);

  const today = new Date().toLocaleDateString('vi-VN', { 
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' 
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('skillmatch_token');
        const API_URL = process.env.REACT_APP_API_BASE_URL;
        
        // Gọi API thống kê
        const res = await fetch(`${API_URL}/api/dashboard/stats`, {
            headers: { 'x-auth-token': token }
        });
        
        if (res.ok) {
            const result = await res.json();
            setData(result);
       
        } else {
            console.error("Failed to fetch dashboard stats");
        }
      } catch (error) {
        console.error("Dashboard Error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  
  

  const { user, stats, jobs, tests, activities } = data;

  // --- LOGIC TRẠNG THÁI NÂNG CAO (Copy từ JobManagement) ---
  const getDisplayStatus = (job) => {
      const now = new Date();
      const start = job.startDate ? new Date(job.startDate) : null;
      const end = job.deadline ? new Date(job.deadline) : null;

      if (job.status === 'DRAFT') {
          return { label: 'Bản nháp', className: 'bg-gray-100 text-gray-600 border-gray-200' };
      }
      if (job.status === 'Tạm dừng') {
            return { label: 'Tạm dừng', className: 'bg-yellow-100 text-yellow-700 border-yellow-200' };
      }
      if (end && now > end) {
          return { label: 'Đã kết thúc', className: 'bg-red-50 text-red-600 border-red-200' };
      }
      if (start && now < start) {
          return { label: 'Sắp mở', className: 'bg-blue-50 text-blue-600 border-blue-200' };
      }
      return { label: 'Đang tuyển', className: 'bg-emerald-100 text-emerald-700 border-emerald-200' };
  };

  if (loading) return (
    <div className="flex h-96 items-center justify-center">
        <div className="flex h-64 items-center justify-center text-gray-400">Đang tải dữ liệu...</div>
    </div>
  );

  return (
    <div className="space-y-8">
      
      {/* HEADER SECTION */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4">
        <div>
            <h1 className="text-3xl font-bold text-gray-900 tracking-tight">Xin chào, {user?.name || 'Doanh nghiệp'} </h1>
            <p className="text-gray-500 mt-2 flex items-center gap-2">
                <span className="material-symbols-outlined text-lg">calendar_today</span>
                <span className="capitalize">{today}</span>
            </p>
        </div>
        <div className="flex gap-3">
             <Link to="/business/jobs/new" className="flex items-center gap-2 bg-blue-600 text-white px-5 py-2.5 rounded-lg font-semibold shadow-md hover:bg-blue-700 transition-all">
                <span className="material-symbols-outlined text-xl">add</span> Đăng tin mới
            </Link>
        </div>
      </div>

      {/* METRICS GRID */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Metric 1 */}
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-center justify-between hover:shadow-md transition-shadow">
          <div>
            <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">Tin tuyển dụng</p>
            <p className="text-4xl font-extrabold text-gray-900 mt-2">{stats?.activeJobs || 0}</p>
            <span className="text-sm text-emerald-600 font-medium flex items-center gap-1 mt-1">
                <span className="material-symbols-outlined text-sm">trending_up</span> Đang hoạt động
            </span>
          </div>
          <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center">
            <span className="material-symbols-outlined text-2xl">work</span>
          </div>
        </div>

        {/* Metric 2 */}
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-center justify-between hover:shadow-md transition-shadow">
          <div>
            <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">Ứng viên mới</p>
            <p className="text-4xl font-extrabold text-gray-900 mt-2">{stats?.newCandidates || 0}</p>
            <span className="text-sm text-blue-600 font-medium flex items-center gap-1 mt-1">
                 Cần duyệt
            </span>
          </div>
          <div className="w-12 h-12 bg-purple-50 text-purple-600 rounded-xl flex items-center justify-center">
            <span className="material-symbols-outlined text-2xl">group_add</span>
          </div>
        </div>

        {/* Metric 3 */}
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-center justify-between hover:shadow-md transition-shadow">
          <div>
            <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">Bài Test Hoàn Thành</p>
            <p className="text-4xl font-extrabold text-gray-900 mt-2">{stats?.completedTests || 0}</p>
            <span className="text-sm text-gray-500 font-medium mt-1 block">Trong tháng này</span>
          </div>
          <div className="w-12 h-12 bg-orange-50 text-orange-600 rounded-xl flex items-center justify-center">
            <span className="material-symbols-outlined text-2xl">fact_check</span>
          </div>
        </div>
      </div>

      {/* MAIN CONTENT GRID */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        
        {/* LEFT COLUMN (2/3) */}
        <div className="lg:col-span-2 space-y-8">
            
            {/* Recent Jobs */}
            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
                    <h3 className="font-bold text-gray-900">Tin tuyển dụng gần đây</h3>
                    <Link to="/business/jobs" className="text-sm text-blue-600 font-medium hover:underline">Xem tất cả</Link>
                </div>
                <div className="divide-y divide-gray-100">
                    {jobs && jobs.length > 0 ? jobs.map(job => {
                        const statusObj = getDisplayStatus(job);
                        return (
                            <div key={job._id} className="p-5 hover:bg-gray-50 transition-colors flex items-center justify-between group">
                                <div>
                                    <h4 className="font-bold text-gray-900 group-hover:text-blue-600 transition-colors">{job.title}</h4>
                                    <div className="flex items-center gap-3 text-sm text-gray-500 mt-1">
                                        <span>{job.type}</span>
                                        
                                    </div>
                                </div>
                                <span className={`px-3 py-1 rounded-full text-xs font-bold border ${statusObj.className}`}>
                                    {statusObj.label}
                                </span>
                            </div>
                        );
                    }) : (
                        <div className="p-8 text-center text-gray-500">Chưa có tin tuyển dụng nào</div>
                    )}
                </div>
            </div>

            {/* Recent Tests */}
            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
                    <h3 className="font-bold text-gray-900">Bài kiểm tra kỹ năng</h3>
                    <Link to="/business/tests" className="text-sm text-blue-600 font-medium hover:underline">Quản lý kho đề</Link>
                </div>
                <div className="divide-y divide-gray-100">
                    {tests && tests.length > 0 ? tests.map(test => (
                        <div key={test._id} className="p-5 hover:bg-gray-50 transition-colors flex items-center justify-between">
                            <div className="flex items-center gap-4">
                                <div className="w-10 h-10 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center">
                                    <span className="material-symbols-outlined">quiz</span>
                                </div>
                                <div>
                                    <h4 className="font-bold text-gray-900 text-sm">{test.assessmentName}</h4>
                                    <p className="text-xs text-gray-500 mt-0.5">{test.timeLimit} phút • {test.testType}</p>
                                </div>
                            </div>
                             <span className={`px-2.5 py-0.5 rounded-full text-[11px] font-bold ${test.status === 'PUBLISHED' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
                                {test.status === 'PUBLISHED' ? 'Đang mở' : 'Nháp'}
                            </span>
                        </div>
                    )) : (
                        <div className="p-8 text-center text-gray-500">Chưa có bài test nào</div>
                    )}
                </div>
            </div>
        </div>

        {/* RIGHT COLUMN (1/3) - Activities */}
        <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm h-full max-h-[600px] overflow-hidden flex flex-col">
                <div className="px-6 py-4 border-b border-gray-100 bg-gray-50/50">
                    <h3 className="font-bold text-gray-900">Hoạt động gần đây</h3>
                </div>
                <div className="p-6 overflow-y-auto custom-scrollbar flex-1">
                    <div className="relative pl-4 border-l-2 border-gray-100 space-y-6">
                        {activities && activities.length > 0 ? activities.map((act, idx) => (
                            <div key={idx} className="relative">
                                <div className="absolute -left-[21px] top-1 w-3 h-3 rounded-full border-2 border-white ring-1 ring-gray-200" style={{ backgroundColor: act.color || '#3b82f6' }}></div>
                                <p className="text-sm text-gray-900 leading-snug">
                                    <span className="font-semibold">{act.user}</span> {act.action} <span className="font-semibold text-blue-600">{act.target}</span>
                                </p>
                                <span className="text-xs text-gray-400 mt-1 block font-medium">{act.time}</span>
                            </div>
                        )) : (
                            <p className="text-sm text-gray-400 italic">Chưa có hoạt động nào.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>

      </div>
    </div>
  );
}